const notification = document.createElement("div");
const anim = document.createElement("style");

notification.style.cssText = `
  position: absolute;
  z-index: 9999;
  top: 10px;
  right: 10px;
  transform: translateX(calc(100% + 20px));
  padding: 10px;
  margin: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #0005;
  color: #fff;
`;

anim.textContent = `
  @keyframes slide {
      0%, 100% {
          transform: translateX(calc(100% + 20px));
      }
  
      10%, 90% {
          transform: translateX(0);
      }
  }
  
  .anim {
      animation: slide 2s forwards;
  }
`;

function waitFor<T>(
  check: () => T | null | undefined | false,
  interval = 50,
): Promise<T> {
  return new Promise((resolve) => {
    let timer: ReturnType<typeof setInterval> | undefined;

    const run = (): boolean => {
      try {
        const result = check();

        if (result) {
          if (timer) clearInterval(timer);
          resolve(result);
          return true;
        }
      } catch (err) {
        if (typeof isDevelopment !== "undefined" && isDevelopment)
          console.error(err);
      }

      return false;
    };

    if (!run()) timer = setInterval(run, interval);
  });
}

waitFor(() => document.body).then(() => {
  document.body.append(notification, anim);
});

function notify(message: string): void {
  notification.innerHTML = message;
  notification.className = "";

  void notification.offsetHeight;
  notification.className = "anim";
}

window.notify = notify;

export default notify;
